// extracted by mini-css-extract-plugin
export default {"sectionMessages":"styles_sectionMessages__a8j7H","listMessages":"styles_listMessages__Bc-Xx"};